import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, MessageCircle, ArrowRight } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/site";

export const ExitPopup = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("hs_exit_shown")) return;
    const onMouseLeave = (e) => {
      if (e.clientY <= 0 && !sessionStorage.getItem("hs_exit_shown")) {
        sessionStorage.setItem("hs_exit_shown", "1");
        setShow(true);
      }
    };
    document.addEventListener("mouseleave", onMouseLeave);
    return () => document.removeEventListener("mouseleave", onMouseLeave);
  }, []);

  const close = () => setShow(false);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[90] flex items-center justify-center bg-[#040910]/80 p-4 backdrop-blur-sm"
          onClick={close}
          data-testid="exit-intent-overlay"
        >
          <motion.div
            initial={{ scale: 0.94, opacity: 0, y: 24 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.96, opacity: 0, y: 12 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="relative w-full max-w-md rounded-[2rem] border border-white/10 bg-[#0B192C] p-9 shadow-2xl shadow-black/60"
            onClick={(e) => e.stopPropagation()}
            data-testid="exit-intent-modal"
          >
            <button
              onClick={close}
              data-testid="exit-intent-close"
              aria-label="Close popup"
              className="absolute right-5 top-5 rounded-full p-2 text-slate-500 transition-colors hover:bg-white/5 hover:text-white"
            >
              <X className="h-5 w-5" />
            </button>
            <span className="font-mono-x text-[10px] uppercase tracking-[0.3em] text-amber-500">
              Before You Go
            </span>
            <h3 className="font-display mt-4 text-2xl font-bold text-white">
              Have a Healthcare Requirement?
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-400">
              Tell us what you need help with — our team will get in touch.
            </p>
            <div className="mt-8 flex flex-col gap-3">
              <a
                href="#enquiry"
                onClick={close}
                data-testid="exit-intent-submit"
                className="group inline-flex items-center justify-center gap-2 rounded-full bg-teal-500 px-7 py-3.5 text-sm font-bold text-[#060D17] transition-all duration-300 hover:bg-teal-400"
              >
                Request a Consultation
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </a>
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="exit-intent-whatsapp"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-emerald-500/40 px-7 py-3.5 text-sm font-semibold text-emerald-400 transition-all duration-300 hover:bg-emerald-500/10"
              >
                <MessageCircle className="h-4 w-4" />
                Chat on WhatsApp
              </a>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
